import * as React from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import "antd/dist/antd.css";  // TODO: antd v5 drops this precompiled styles. Use components!
import "./Library.css";

import { AddinCard } from "../Card/AddinCard";
import { AddinsData } from "../../utils/AddinsData";

let currencyData = {};
let AddinCards = {};
let postFetchCurrencyRender = null;
// action to scroll to the robot name
window.addEventListener('load', async() => {
    currencyData = await window.fetchCurrency();

    Object.entries(AddinsData.DATA_ALL).map((entry) => {
        const [key, addin] = [entry[0], entry[1]];
        
        // TODO: do we really need the defaultToEur flag? We shouldn't... it should rely on Globals.tsx and _myinfo 
        if (addin.hasOwnProperty("PX")) {
            if (!addin.PX.hasOwnProperty(currencyData["Currency"])) {
                currencyData["Currency"] = "eur";
            }
        }

        // TODO: use the format_cur function provided in Globals to display

        AddinCards[addin["N"]] = <AddinCard 
            name = {addin["N"]}
            file = {addin["F"]}
            package_name = {(addin.hasOwnProperty("ID")) ? addin["ID"] : ""}
            folder_name = {addin["BN"]}
            image = {(addin.hasOwnProperty("I")) ? addin["I"] : "" }
            md = {(addin.hasOwnProperty("MD")) ? addin["MD"] : ""}
            publisher = {addin["P"]}
            category = {addin["C"]}
            description = {addin["D"]}
            version = {addin["V"]}
            form_num = {addin.hasOwnProperty("CF") ? addin["CF"] : 0}
            link = {addin["link"]}
            price = {addin.hasOwnProperty("PX") ? addin.PX[currencyData["Currency"]] : 'Free'}
            currency = {addin.hasOwnProperty("PX") ? currencyData["Currency"] : "Free"}
        />
    });

    postFetchCurrencyRender ? postFetchCurrencyRender(true) : null;

    let showname = /n=([^&]+)/.exec(window.location.search);
    if (!showname){ return; }
    let robid = document.getElementById(showname[1]);
    if (!robid){ return; }
    //console.log("Scrolling to: " + showname[1])
    robid.scrollIntoView({ behavior: 'smooth', block: "center" });
});

const start = performance.now();

console.log("Setup time (ms): " + (performance.now() - start));

export const AddinLib = (props: any) => {
    const [init, setInit] = React.useState(true);
    const [fetchedCurrency, setFetchedCurrency] = React.useState(false);
    const [range, setRange] = React.useState(20);

    const updateRange = () => {
        setRange(range + 20);
    };

    React.useEffect(() => {
        if (init) {
            // The following chceks won't work from parent iframe, i.e. library
            // if want to work, have to add extra code to receive params
            // from parent before check

            // Check if library is opened from RoboDK app
            // either from url query or cookie
            if (window.location.search.includes("RDK&")) {
                window.CookieHandler.setCookie("RDK-Available", "1", 730);
                window.Settings.open_in_rdk = true;
            } else {
                if (window.CookieHandler.isSet("RDK-Available")) {
                    window.Settings.open_in_rdk = true;
                }
            }

            // Check if library is opened from RoboDK Web
            if (window.location.search.includes("RoboDK-Web&")) {
                window.Settings.open_in_rdk = true;
                window.Settings.on_robodk_web = true;
            }
            postFetchCurrencyRender = setFetchedCurrency;

            let showname = /n=([^&]+)/.exec(window.location.search);

            if (showname != null) {
                let rob_index = Object.entries(props.sortFilteredAddins).findIndex(
                    ([entry, index]) => entry == showname[1]
                )
                //console.log('showname', showname);
                //console.log('index', rob_index);

                setRange(range + rob_index);
            } else {
                setRange(range);
            }

            setInit(false);
        }
    });

    return (
        <>
            <div className="library-robots">
                {/* 
                    Commented because some of the translations aren't available 
                    and is this being used? It doesn't show any difference without it
                */}
                {/* <div className="section-top-hidden">
                    <label className="float-left" htmlFor="sortBy">
                        {t('library.sortBy')})}
                    </label>
                    <Dropdown className="float-left">
                        <Dropdown.Toggle className="dropdown-toggle">
                            {t(sortDDStringA) +
                                " (" +
                                t(sortDDStringB) +
                                "-" +
                                t(sortDDStringC) +
                                ")"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="sort-dd-menu">
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Name ASC"
                            >
                                {t('robot.attributes.name')}) + " "}(A-Z)
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Name DESC"
                            >
                                {t('robot.attributes.name')}) + " "}(Z-A)
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Reach ASC"
                            >
                                {t('robot.attributes.reach')}) +
                                    " (" +
                                    t() +
                                    " - " +
                                    {t('library.high')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Reach DESC"
                            >
                                {t('robot.attributes.reach')}) +
                                    " (" +
                                    {t('library.high')}) +
                                    " - " +
                                    {t('library.low')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Payload ASC"
                            >
                                {t('robot.attributes.payload')}) +
                                    " (" +
                                    {t('library.low')}) +
                                    " - " +
                                    {t('library.high')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Payload DESC"
                            >
                                {t('robot.attributes.payload')}) +
                                    " (" +
                                    {t('library.high')}) +
                                    " - " +
                                    {t('library.low')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="WeightTotal ASC"
                            >
                                {t('robot.attributes.weight')}) +
                                    " (" +
                                    {t('library.low')}) +
                                    " - " +
                                    {t('library.high')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="WeightTotal DESC"
                            >
                                {t('robot.attributes.weight')}) +
                                    " (" +
                                    {t('library.high')}) +
                                    " - " +
                                    {t('library.low')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Repeatability ASC"
                            >
                                {t('robot.attributes.repeatability')}) +
                                    " (" +
                                    {t('library.low')}) +
                                    " - " +
                                    {t('library.high')}) +
                                    ")"}
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={handleSortBy}
                                name="Repeatability DESC"
                            >
                                {t('robot.attributes.repeatability')}) +
                                    " (" +
                                    {t('library.high')}) +
                                    " - " +
                                    {t('library.low')}) +
                                    ")"}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <div className="float-clear"></div>
                </div> */}
                <InfiniteScroll
                    style={{ 
                        overflow: 'visible'
                    }}
                    dataLength={range}
                    next={updateRange}
                    hasMore={true}
                    loader={<h4></h4>}
                    endMessage={''}
                >
                    <div className="row cards">
                        {props.noResultMessage != "" && (
                            <h4>{props.noResultMessage}</h4>
                        )}
                        {/* {props.sortFilteredAddins.map((addin) => { */}
                        {/* {props.sortFilteredAddins.slice(0, range).map((addin) => { */}
                        {Object.entries(props.sortFilteredAddins).slice(0, range).map((entry) => {
                            const [key, addin] = [entry[0], entry[1]];

                            return (
                            <div
                                key={"row-" + addin["N"]}
                                className="card g-2 col col-12 col-sm-6 col-md-4 col-xl-3 col-xxl-3"
                            >
                                {AddinCards[addin["N"]]}
                            </div>
                            )
                        })}
                    </div>
                </InfiniteScroll>
            </div>
        </>
    );
};
